import { SearchClient } from './client';
import { getSlots } from './queries/slots';
import { getProviderById } from './queries/providerbyid';
import { getLocations } from './queries/locations';
import { getProviders } from './queries/providers';
/**
 * Fully-configured client for interacting with the search service.
 *
 * All query functions are accessible directly on the client instance.
 * If you'd rather include only the query functions you need, use
 * {@link SearchClient} instead.
 *
 * @category Clients
 *
 * @example
 * ```typescript
 * import { Search } from '@kyruus/search-sdk';
 *
 * // Instantiate the search client
 * const searchClient = new Search({
 *   version: 'v9',
 *   authToken
 * });
 *
 * // Execute a query using a provided query function
 * const results = await searchClient.getSlots({ perPage: 25 });
 * ```
 */
export class Search extends SearchClient {
    constructor(config) {
        super(config);
    }
    /** Query function for operations around locations data.
     * @param input input parameters for paring down the search results
     */
    getLocations(input) {
        return this.query(getLocations, input);
    }
    /** Query function for operations around slots data.
     * @param input input parameters for paring down the search results
     */
    getSlots(input) {
        return this.query(getSlots, input);
    }
    /** Query function for retrieving providers by provider ID.
     * @param input input parameters for paring down the search results
     */
    getProviderById(input) {
        return this.query(getProviderById, input);
    }
    /** Query function for operations around providers data.
     * @param input input parameters for paring down the search results
     */
    getProviders(input) {
        return this.query(getProviders, input);
    }
}
//# sourceMappingURL=fullClient.js.map